import React from 'react'


import InputFieldA14input from '../../CommonUtils/InputFieldA14input'

const MessageA14input = (props) => {
  return (
    <div>
      <InputFieldA14input {...props} />
    </div>
  )
}

export default MessageA14input
